import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Single.css";
import { Sidebar } from "../../components/sidebar/Sidebar";
import { Navbar } from "../../components/navbar/Navbar";
import Chart from "../../components/chart/Chart";
import List from "../../components/table/Table";

const Single = () => {
  const [userData, setUserData] = useState(null);
  const [userTransactions, setUserTransactions] = useState([]);
  const userId = "id"; // Remplacez par l'ID réel de l'utilisateur

  // Récupérer les informations de l'utilisateur
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`http://localhost:5000/api/auth/users/${userId}`);
        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    const fetchUserTransactions = async () => {
      try {
        const response = await axios.get(`http://localhost:5000/api/orders/${userId}`);
        setUserTransactions(response.data);
      } catch (error) {
        console.error("Error fetching user transactions:", error);
      }
    };

    fetchUserData();
    fetchUserTransactions();
  }, [userId]);

  if (!userData) return <div>Loading...</div>; // Afficher un message de chargement si les données ne sont pas encore récupérées

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="editButton">Edit</div>
            <h1 className="title">Information</h1>
            <div className="item">
              <img
                src={userData.profilePicture || "https://images.pexels.com/photos/428333/pexels-photo-428333.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}
                alt="User Profile"
                className="itemImg"
              />
              <div className="details">
                <h1 className="itemTitle">{userData.name}</h1>
                <div className="detailItem">
                  <span className="itemKey">Email:</span>
                  <span className="itemValue">{userData.email}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Phone:</span>
                  <span className="itemValue">{userData.phone}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Address:</span>
                  <span className="itemValue">{userData.address}</span>
                </div>
                <div className="detailItem">
                  <span className="itemKey">Country:</span>
                  <span className="itemValue">{userData.country}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="right">
            <Chart aspect={3 / 1} title="User Spending (last 6 months)" />
          </div>
        </div>
        <div className="bottom">
          <h1 className="title">Last Transactions</h1>
          <List transactions={userTransactions} />
        </div>
      </div>
    </div>
  );
};

export default Single;
